import { Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import React from "react";
import TitleDescription from "../components/TitleDescription";
import { ReactComponent as FinfactorProductsGrid } from "../assets/finfactor-products-grid.svg"
import { ReactComponent as HowFinfactorWorks } from "../assets/how-finfactor-works.svg"
import Title from "../components/Title";

const HomePage: React.FC = React.memo(() => {
    return (
        <Box sx={{
            paddingX: 6
        }}>
            <Grid container justifyContent="center" alignItems="center">
                <Grid size={6}>
                    <TitleDescription
                        title="Finfactor’s Developer Documentation"
                        description="A suite of APIs designed to power innovative financial solutions. Our APIs enable seamless integration for key functions such as wealth management, lending and collections, fraud detection, and more. With a focus on simplicity and speed, we offer developer-friendly tools that help you build, scale, and launch financial applications with confidence."
                    />
                </Grid>
                <Grid size={6}>
                    <FinfactorProductsGrid />
                </Grid>
            </Grid>
            <>
                <Title title="How Finfactor works?" paddingBottom={4} />
                <HowFinfactorWorks />
            </>
        </Box>
    );
});

export default HomePage;
